import React, { useLayoutEffect, useContext } from 'react';
import utils from '@/common/utils';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import defaultData from '../../../constants/data';
import { useHistory } from 'react-router-dom';
import CollectionPoolList from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/collection-pool-list/index.js';
import PoolList from '@/pages/activity-manage/merchants/venue-detail/micro-app-pages/pool-list';

export default function EffectData({ data = defaultData }) {
  const history = useHistory();
  const { isManage } = useContext(ContextProviderMenus);

  useLayoutEffect(() => {
    if (isManage == null) return;
    // entry: 0 管理员 1 参与者
    // efficacyData: 效果数据
    // hideTab: 1 隐藏tab
    // areaId: 如果存在则是收品池详情 efficacyData: 2，如果areaId不存在 efficacyData: 1
    let queryObj = utils.parseQuery(window.location.search);

    queryObj.entry = isManage ? 0 : 1;
    queryObj.efficacyData = queryObj.areaId ? 2 : 1;
    queryObj.hideTab = 1;
    // 优化只请求当前页接口
    queryObj.tabName = 'efficacy-list';
    queryObj.activityId = queryObj.id = queryObj.id || queryObj.activityId;

    history.replace(window.location.pathname + `?${utils.formatQueryObj(queryObj)}`);
    // eslint-disable-next-line
  }, [isManage]);

  // 管理者 http://test.mc.jd.com/dist/pages/activeManageBlock/?entry=0&activityId=10595448&areaId=14960467&efficacyData=2
  // 参与者 http://test.mc.jd.com/dist/pages/activeEnrollBlock/?entry=1&activityId=10595448&areaId=14960467&efficacyData=2
  // return <Microapp data={data} destory name="effectData" url={`${env.MC_DOMAIN}/dist/pages/activeManageBlock/`} />;
  return isManage ? <CollectionPoolList destory data={data} /> : <PoolList destory data={data} />;
}
